import { ConfigSettingsService } from '../../providers';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RegexService {
  private readonly configSettingsService = inject(ConfigSettingsService);

  public getPersonalNumberRegex(): RegExp {
    return new RegExp(`^\\d{${this.configSettingsService.appSettings.personalNumberLength}}$`);
  }
}
